import VDaterange from './VDaterange';
const VuetifyDaterangePicker = {
  install(Vue) {
    Vue.component(VDaterange.name, VDaterange);
  }
};
export default VuetifyDaterangePicker;
export { VDaterange };
